import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './Link.scss';
import { LINK_SEVERITY } from './constants';
import { Icon, SvgDownload, SvgExternal } from '../../index';
export { LINK_SEVERITY };
export const Link = (props) => {
    let className = '';
    className += props.severity === LINK_SEVERITY.COLORLESS ? ' sg-link-colorless' : '';
    className += props.severity === LINK_SEVERITY.COLORFUL ? ' sg-link-colorful' : '';
    className += props.severity === LINK_SEVERITY.UNDERLINED ? ' sg-link-underlined' : '';
    className += props.isHovered ? ' sg-link-isHovered' : '';
    className += props.isExternal ? ' sg-link-isExternal' : '';
    return (_jsxs("a", { className: 'sg-link' + className, href: props.href, target: props.target, title: props.tooltip, download: props.download, rel: 'noopener', onClick: props.onClick, children: [_jsx("span", { className: 'sg-link--text', children: props.children }), props.isExternal && (_jsxs(_Fragment, { children: ['\u202f', _jsx(Icon, { element: _jsx(SvgExternal, {}) })] })), props.download && (_jsxs(_Fragment, { children: ['\u202f', _jsx(Icon, { element: _jsx(SvgDownload, {}) })] }))] }));
};
//# sourceMappingURL=Link.js.map